import React from 'react';
import ReactDOM from 'react-dom';
import './sass/style.scss';
import './config/firebase';
import Routes from './Routes';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
// import ImportNotification from './components/importNotification';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <ImportNotification /> */}
      <Routes />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
